import { useEffect, useState } from "react";
var useDate = function useDate(_a) {
  var interval = (_a === void 0 ? {} : _a).interval;
  var _b = useState(new Date()),
    date = _b[0],
    setDate = _b[1];
  useEffect(function () {
    var intervalId;
    var bump = function bump() {
      intervalId = setTimeout(function () {
        setDate(new Date());
        bump();
      }, nextCallback(new Date(), interval));
    };
    bump();
    return function () {
      return intervalId && clearInterval(intervalId);
    };
  });
  return date;
};
export default useDate;
export var nextCallback = function nextCallback(now, interval) {
  if (typeof interval === "number") {
    return interval;
  } else if (interval === "second") {
    return 1000 - now.getMilliseconds();
  } else if (interval === "minute") {
    return 60 * 1000 - now.getMilliseconds() - now.getSeconds() * 1000;
  } else if (interval === "hour") {
    return 60 * 60 * 1000 - now.getMilliseconds() - now.getSeconds() * 1000 - now.getMinutes() * 60 * 1000;
  } else {
    return 1000 - now.getMilliseconds();
  }
};